<script>
import { Bar, Line, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins


export default {
    mixins: [Line, Bar, reactiveProp],
    props: {
        threshold: {
            type: Number,
            default: 0,
            required: true
        }
    },
    data() {
        return {
            options: {
                responsive: true,
                animation: false,
                legend: {
                    position: "bottom"
                },
                scales: {
                    xAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: '時間(24h)',
                            offset: true
                        }
                    }],
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            stepSize: 10,
                            max: 30
                        },
                        scaleLabel: {
                            display: true,
                            labelString: '最大人数(人)'
                        }
                    }]
                }
            }
        }
    },
    mounted() {
        
        this.options.scales.yAxes[0].ticks.max = this.threshold
        
        // グラフ生成
        this.renderChart(this.chartData, this.options)
    },
    
    watch: {
        // refresh ※メモリリーク対策
        chartData(val) {
            this._data._chart.destroy()
            this.renderChart(val, this.options)
        },
        threshold(num) {
            this._data._chart.destroy()
            this.options.scales.yAxes[0].ticks.max = num
            this.renderChart(this.chartData, this.options)
        }
    },
}

</script>